import { css } from 'twin.macro';
import { customCheckbox } from '@/_elements/CustomCheckbox';
import React, { Fragment } from 'react';
import { Form } from 'react-bootstrap';

const AUTOFILL_FIELD_OPTIONS = [
    { label: 'None', value: '' },
    { label: 'Address', value: 'address' },
    { label: 'Email', value: 'email' },
    { label: 'Name', value: 'name' },
    { label: 'Phone', value: 'phone' },
    { label: 'Client: Full Name', value: 'client.fullName' },
    { label: 'Client: First Name', value: 'client.firstName' },
    { label: 'Client: Last Name', value: 'client.lastName' },
    { label: 'Client: Identifier', value: 'client.identifier' },
    { label: 'Client: Caregiver Name', value: 'client.caregiverName' },
    { label: 'Client: Caregiver Phone', value: 'client.caregiverPhone' },
    { label: 'Client: Allergies', value: 'client.allergies' },
    { label: 'Client: Healthcare Practitioner Name', value: 'client.healthcarePractitionerName' },
    { label: 'Client: Diagnosis', value: 'client.diagnosis' },
    { label: 'Client: Date of Birth (DOB)', value: 'client.dateOfBirth' },
];
const FieldOptions = ({ element, register }) => {
    return (
        <Fragment>
            {/* maxLength */}
            {element.key === 'InputField' && (
                <Fragment>
                    <Form.Group
                        controlId="maxLengthInput"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Form.Label style={{ marginRight: '10px', marginBottom: '0' }}>
                            Maximum characters allowed:
                        </Form.Label>
                        <Form.Control
                            type="number"
                            placeholder=""
                            defaultValue={(element?.options || {})?.maxLength}
                            name="options.maxLength"
                            ref={register}
                            onWheel={(event) => event.currentTarget.blur()}
                            min={0}
                            style={{ width: '300px' }}
                        />
                    </Form.Group>
                    <Form.Group
                        controlId="autofillFieldSelect"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Form.Label>Choose Autofill Field:</Form.Label>
                        <Form.Control
                            as="select"
                            name="options.autofillField"
                            ref={register}
                            defaultValue={
                                (element?.options || {})?.autofillField || (element?.config || {})?.autofillField
                            }
                            // onChange={handlePrepopulateChange}
                            style={{ width: '300px' }}
                        >
                            {AUTOFILL_FIELD_OPTIONS.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                </Fragment>
            )}
            {/* Show Field Title in Pdf Template */}
            {element.key === 'Signature' && (
                <Form.Group
                    controlId="showTitleInPdfTemplateView"
                    css={css`
                        display: flex;
                        align-items: center;
                        .requiredCheckbox {
                            width: 20px;
                            height: 20px;
                        }
                    `}
                >
                    <Form.Control
                        className="requiredCheckbox"
                        type="checkbox"
                        css={customCheckbox}
                        name="options.showTitleInPdfTemplateView"
                        defaultChecked={(element?.options || {}).showTitleInPdfTemplateView || false}
                        ref={register({
                            setValueAs: (value) => !!value,
                        })}
                    />
                    <Form.Label
                        css={css`
                            margin: 0;
                        `}
                    >
                        Show field title in PDF template
                    </Form.Label>
                </Form.Group>
            )}
        </Fragment>
    );
};

export default FieldOptions;
